import './EditorTabs.css';

function EditorTabs({ openFiles, activeFile, onFileChange, onFileClose }) {
    if (openFiles.length === 0) {
        return null;
    }

    const getFileName = (path) => {
        const parts = path.split('/');
        return parts[parts.length - 1];
    };

    const getFileIcon = (name) => {
        const ext = name.split('.').pop().toLowerCase();
        const iconMap = {
            js: '/svg/javascript-plain.svg',
            jsx: '/svg/javascript-plain.svg',
            py: '/svg/python.svg',
            json: '/svg/file-code.svg',
            md: '/svg/markdown.svg',
            css: '/svg/file-type-svg.svg',
            html: '/svg/html5.svg',
            ts: '/svg/typescript-plain.svg',
            tsx: '/svg/brand-typescript.svg',
            svg: '/svg/file-type-svg.svg',
            pdf: '/svg/file-pdf.svg',
        };
        return iconMap[ext] || '/svg/file-line.svg';
    };

    return (
        <div className="editor-tabs">
            {openFiles.map((filePath) => {
                const fileName = getFileName(filePath);
                const isActive = filePath === activeFile;

                return (
                    <div
                        key={filePath}
                        className={`tab ${isActive ? 'active' : ''}`}
                        onClick={() => onFileChange(filePath)}
                    >
                        <img src={getFileIcon(fileName)} alt="" className="tab-icon" />
                        <span className="tab-label">{fileName}</span>
                        <button
                            className="tab-close"
                            onClick={(e) => {
                                e.stopPropagation();
                                onFileClose(filePath);
                            }}
                            title="Close"
                        >
                            ×
                        </button>
                    </div>
                );
            })}
        </div>
    );
}

export default EditorTabs;
